(function () {
    'use strict';

    angular
        .module('app.lostAndFound')
        .run(appRun);

    appRun.$inject = ['routerHelper', 'opsIncludeVersion'];
    /* @ngInject */
    function appRun(routerHelper, opsIncludeVersion) {
        routerHelper.configureStates(getStates(opsIncludeVersion));
    }

    function getStates(opsIncludeVersion) {
        return [
              {
                state: 'lostandfound',
                  config: {
                      abstract: true,
                      url: '/lostandfound',
                      template: '<ui-view/>',
                      settings: {
                              authMode: 1
                      },
                      resolve: {
                        authenticationRequired: ['userService', function (userService) {
                            if (userService.userType() == "0") {
                                throw { name: "NotAdmin" };
                            }
                        }]
                     }
                  },
              },
            {
                state: 'lostandfound.list',
                config: {
                    url: '/list',
                    templateUrl: 'app/lostAndFound/list.html?v=' + opsIncludeVersion,
                    controller: 'LostAndFoundListController',
                    controllerAs: 'vm',
                    title: 'Lost and Found',
                 
                }
            },
            {
                state: 'lostandfound.details',
             config: {
                 url: '/detail/:id',
                 templateUrl: 'app/lostAndFound/details.html?v=' + opsIncludeVersion,
                 controller: 'LostAndFoundDetailsController',
                 controllerAs: 'vm',
                 title: 'Item Details',
             }
            }
          
        ];
    }
})();
